import React, { useContext, useEffect, useCallback } from 'react';
import { METRICS, MINIMUM_LIFT_PERCENTAGE } from '../../utils/Constants';
import CustomRadioButton from '../../components/CustomRadioButton';
import { metricItems } from '../../utils/ABHelper';
import { ABContext } from '../../contexts/ABContext';
import ScoreWeightage from './ScoreWeightage';
import InputBoxWinThreshold from '../../components/InputBoxWinThreshold';
import { TPayload } from '../../types/ab';
import Typography from 'Components/DesignSystem/Typography/Typography';


const MetricsSection = () => {
    const abContext = useContext(ABContext);

    useEffect(() => {
        if (abContext?.payload) {
            abContext.setPayload((prevPayload: TPayload) => ({
                ...prevPayload,
                metric: prevPayload.metric || 'Revenue',
                win_threshold: prevPayload.win_threshold ?? 0
            }));
        }
    }, []);

    const handleMetricChange = useCallback((newMetric: string | ((prevState: string) => string)) => {
        if (abContext?.setPayload) {
            abContext.setPayload((prevPayload: TPayload) => {
                const updatedMetric = typeof newMetric === 'function' ? newMetric(prevPayload.metric || '') : newMetric;
                const updatedPayload = { ...prevPayload, metric: updatedMetric };

                if (updatedMetric !== 'Score') {
                    updatedPayload.score_weightage = [];
                }

                return updatedPayload;
            });
        }
    }, []);

    const handleWinThresholdChange = useCallback((newThreshold: number) => {
        if (abContext?.setPayload) {
            abContext.setPayload((prevPayload: TPayload) => ({
                ...prevPayload,
                win_threshold: newThreshold ?? 0
            }));
        }
    }, []);

    return (
        <section className='tw-my-4 tw-pb-6 tw-border-b tw-border-edge'>
            {/* The caption names the radiogroup below it — it was a `<label>` pointing at
                nothing, above five radios that shared no `name` (§ 143). */}
            <Typography variant="title" as="p" className="tw-text-ink-tertiary" id="ab-metrics-label">
                {METRICS}
            </Typography>
            <CustomRadioButton
                list={metricItems}
                showOverlayIcon={true}
                aria-label={METRICS}
                data-testid="detail-metrics-radio"
                selectedItem={abContext?.payload?.metric || abContext?.DEFAULT_METRIC}
                setSelectedItem={handleMetricChange}
            />
            {abContext?.payload && abContext?.payload?.metric === 'Score' ? <ScoreWeightage /> : null}
            <div className='tw-w-[20%]'>
                <InputBoxWinThreshold
                    onChange={handleWinThresholdChange}
                    initialValue={abContext?.payload?.win_threshold ?? 0}
                    label={MINIMUM_LIFT_PERCENTAGE}
                    data-testid="detail-mlp"
                />
            </div>
        </section>
    );
}

export default MetricsSection;